export default __webpack_public_path__ + "static/media/thum3.4fd8c102.jpg";